module.exports = __webpack_public_path__ + "img/homepage-bg.e04146aa.png";